<template>
  <div class="adventures">
    <top-nav ref="TopNav"></top-nav>
    <!--<van-nav-bar title="积分大转盘" fixed left-arrow @click-left="goBack" @click-right="onClickRight">-->
      <!--<van-icon slot="right" class="iconfont icon-zhankai"></van-icon>-->
    <!--</van-nav-bar>-->
    <div style="padding-top: 0" class="van-content">
      
      <div class="awardRotate">
        <div class="usertit">
        <span class="getTimes" v-if="userdatas != ''">您今天还剩 <span  class="theme-col"> {{ userdatas.day_conut }}</span>次抽奖机会</span>
        <span v-else>敬请期待！</span>
        </div>
        <!--<img src="/static/images/countbanner.png" id="shan-img" style="display:none;" />-->
        <!--<img src="/static/images/hotactimg.jpg" id="sorry-img" style="display:none;" />-->
        <div class="banner">
          <div class="turnplate">
            <canvas class="item" id="wheelcanvas" width="422px" height="422px">
            </canvas>
            <img class="pointer" src="/static/images/pointer.png"  v-on:click="pointer"/>
          </div>
          <div class="turnplate-bottom"><img src="/static/images/turnplate-bottom.png"/></div>
          <div class="turnplate-bottom"><img style="position: absolute;top: -50px;" src="/static/images/blackbg.png"/></div>
        </div>
      </div>
      <van-row style="margin-top: 30px" class="adventures-bot-btn">
        <van-col style="margin-left: 16%" span="8"><van-button size="small" @click="showPlay(2,true)">活动规则</van-button></van-col>
        <van-col span="8"><van-button size="small" @click="getjp(1,true)">我的奖品</van-button></van-col>
      </van-row>
    </div>
    <!--中奖名单-->
    <van-popup v-model="show1" class="adven-popup userlist-popup">
      <div class="hintbox">
        <div class="hintclear" @click="showPlay(1,false)"><img src="/static/images/adventures-clear.png"/></div>
        <p class="title-bg">我的奖品</p>
        <p class="overline"></p>
        <div style="background: #fff" class="hintcent">
       <div v-if="userlist == ''">
          <div style="width: 200px; margin: 50px auto">
          <img src="/static/images/noprize.png"/>
        </div>
        <p style="font-size:16px; text-align:center">您目前没有奖品！</p>
        </div>
          <van-row style="position: relative;"  v-for="(items,index) in userlist" class="userlist jianglist" :key="items.id" v-if="userlist != ''">
            <van-col style="font-size: 13px; margin-top:10px;" class="prizeName" span="6">{{ items.prizename }}</van-col>
            <van-col style="font-size: 13px; text-align:center; width:50%; margin-right:3%; margin-top:10px;height: 17px;" class="prizeName" span="13">{{ items.prize_name }}</van-col>
            <van-col v-if="items.status==0  && items.is_effective!=0"  class="getprize" span="5">
              <div style="color:#FA5A5A !important; "   @click="toget(items.product_code,items.id,items.type)">
                <div style="width: 70%; float: left;">
                  <p style="color:#FA5A5A; text-align:center;">立即</p><p style="color:#FA5A5A; text-align:center;">领取</p>
                </div>
                <div style="width: 30%; float: left;">
                  <i class="van-icon van-icon-arrow van-cell__right-icon righticon"></i>
                </div>
              </div>
            </van-col>
            <!--//已领取-->
            <van-col v-if="items.status==1"  class="hadget" span="5">
               <div style="width: 70%; float: left;">
               <p style="text-align:center;">已</p><p style="text-align:center;">领取</p>
              </div>
              <div style="width: 30%; float: left;">
                  <i class="van-icon van-icon-arrow van-cell__right-icon righticon"></i>
                </div>
            </van-col>
            <van-col v-if="items.is_effective==0" class="hadget" span="5">
               <div style="width: 70%; float: left;">
                <p style="text-align:center;">已</p><p style="text-align:center;">取消</p>
              </div>
              <div style="width: 30%; float: left;">
                  <i class="van-icon van-icon-arrow van-cell__right-icon righticon"></i>
                </div>
            </van-col>
            <span  class="prizeTime" style="font-size:8px">有效时间：{{ items.add_time }}</span>
          </van-row>
        </div>
      </div>
    </van-popup>
    <!--规则-->
    <van-popup v-model="show2" class="adven-popup rule-popup">
      <div class="hintbox">
        <div class="hintclear" @click="showPlay(2,false)"><img src="/static/images/adventures-clear.png"/></div>
        <p class="title-bg">活动规则</p>
        <p class="overline"></p>
        <div   style="background: #fff" class="hintcent">
          <div>
            <p class="tit">活动时间： <span v-if="role != ''">{{ role.activity_config.activity_start_time  }}-{{ role.activity_config.activity_end_time }}</span>
            </p>
           <!-- <p class="tit">奖项设置（积分）：</p> -->
            <!-- <p v-for="items in role.activity_info" :key="items.name" style="margin:5px 0;overflow:hidden"><span class="spone">{{ items.name }}</span><span  class="sptow">{{ items.prize_name }}</span></p> -->
            <p class="tit">活动规则：</p>
            <p v-html="role.activity_config.activity_introduce" v-if="role !=''"></p>
          </div>
          <!--<div class="text-cent">-->
            <!--<van-button size="small" @click="showPlay(2,false)">我知道了</van-button>-->
          <!--</div>-->
        </div>
      </div>
    </van-popup>
    <!--未中奖-->
    <van-popup v-model="show3" class="adven-popup false-popup">
      <div class="hintbox">
        <div class="hintclear" @click="showPlay(3,false)"><img src="/static/images/adventures-clear.png"/></div>
        <div v-if="userdatas.day_conut != 0" class="hintcent">
          <div>
            <van-button size="small" style="background: url('/static/images/btn1.png')no-repeat center; background-size: 80% 80%;" @click="showPlay(3,false)"></van-button>
          </div>
        </div>
        <div v-else-if="userdatas.day_conut == 0" class="hintcent1">
          <div>
            <van-button size="small" style="background: url('/static/images/btn1.png')no-repeat center; background-size: 80% 80%;" @click="showPlay(3,false)"></van-button>
          </div>
        </div>
      </div>
    </van-popup>
    <!--中奖-->
    <van-popup v-model="show4" class="adven-popup true-popup">
      <div class="hintbox">
        <div class="hintclear" @click="showPlay(4,false)"><img src="/static/images/adventures-clear.png"/></div>

        <div class="hintcent">
          <div>
             <div class="truetext">获得{{ truetext }}</div>
            <van-button class="iknow" style="background: url('/static/images/btn.png')no-repeat center; background-size: 80% 80%;" size="small" @click="toget(pid,goodid,goodtype)"></van-button>
          </div>
        </div>
      </div>
    </van-popup>

  </div>
</template>
<script>
  import TopNav from '@/components/topnav'
  import {myfun} from '../../assets/js/awardRotate'
  import 'mint-ui/lib/style.css'
  import {Toast} from 'mint-ui'
  export default {
    name: "adventures",
    components: {
      TopNav,
      myfun
    },
    data () {
      return {
        datas: '',
        show1: false,
        show2: false,
        show3: false,
        show4: false,
        userdatas:'',
        truetext:'',
        userlist:'',
        msg: '',
        province:'',
        city:'',
        town:'',
        county:'',
        pid:'',
        role:'',
        goodid:'',
        goodtype:'',
        turnplate: {
          dengji:[],//奖品等级
          restaraunts: [],//奖项设置
          colors: [],//奖项背景颜色
          images:[],
          outsideRadius: 160,//半径
          textRadius: 125,//圆角半径
          insideRadius: 60,//内圆角半径
          startAngle: 0,
          bRotate: false
        }
      }
    },
    created () {
      this.$nextTick(() => {
        this.turnplate.restaraunts = ['敬请期待!', '敬请期待!', '敬请期待!', '敬请期待!', '敬请期待!']
        this.turnplate.colors = ['rgba(0,0,0,0)']
        this.drawRouletteWheel()
      })
      this.getUserdatas()
      this.getDatas()
    },
    destroyed: function () {
      this.$dialog.close
    },
    methods: {
      goBack: function () {
        history.back(-1);
      },
      onClickRight() {
        this.$refs.TopNav.topnavPlay()
      },
      toget(n,id,type) {
        var goodsId = {}
        var isUser=localStorage.getItem("BLHuser")
        goodsId[n] ="1";
        var strOnDatasId = JSON.stringify(goodsId)/*.replace(/\"/g, "")*/
        if(isUser != null && isUser != '' && isUser != undefined){
          if(type==3){//奖品为积分
            this.$api.post('WebApi/Member/Winning/confirm', 
            {token:isUser,
             activity_winning_id:id
            }, res => {
              this.btnLoading = false
              if(res.data.errCode == '0000'){
                this.$store.commit('userinfo')
                this.$dialog.confirm({
                message: '领取成功',
                showCancelButton:false
              }).then(() => {
                this.showPlay(1,false)
                this.showPlay(4,false)
              })
              }else if(res.data.errCode == '4004'){
                
              }else{
                this.$toast(res.data.desc);
              }
            })
          }else{
            this.$api.post('WebApi/JifenOrder/CreatOrder/index', {token:isUser,goods:strOnDatasId,province:this.province,city:this.city,town:this.town,county:this.county}, res => {
            if(res.data.errCode == '0000'){
              this.$router.push({path:'/affirmOrder',query:{prized:id}})
            }else if(res.data.errCode == '1002'){
              this.$dialog.confirm({
                title:'提示',
                message: '您还未登录是否去登录？'
              }).then(() => {
                this.$router.push({path:'/login'})
              }).catch(() => {
                // on cancel
              });
            }else{
              this.$toast(res.data.errCode)
            }
          })
          }
          
        }else{
          this.$dialog.confirm({
            title:'提示',
            message: '您还未登录是否去登录？'
          }).then(() => {
            this.$router.push({path:'/login'})
          }).catch(() => {
            // on cancel
          });
        }

      },
      showList(index,re){
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('/WebApi/Member/Winning/winning', {token:isUser}, res => {
          if( res.data.errCode == '0000' ) {
            this.userlist=[];
            this.show1 = re
            for(let i=0;i<res.data.data.length;i++){
              if(res.data.data[i].prize_name.length>7){
                res.data.data[i].prize_name = res.data.data[i].prize_name.slice(0,6)+'...'
              }
              if(res.data.data[i].prizename.length>5){
                res.data.data[i].prizename = res.data.data[i].prizename.slice(0,5)+'...'
              }
            }
            this.userlist = res.data.data
          }else{
            this.$dialog.alert({
              title:'提示',
              message: '敬请期待！'
            }).then(() => {
              this.$router.push({path:'/'})
            })
          }
        })
      },
      getjp(index,re){
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('/WebApi/Member/Winning/winning', {token:isUser}, res => {
          if( res.data.errCode == '0000' ) {
            this.show1 = re
            this.userlist = res.data.data
          }else{
            this.$dialog.alert({
              title:'提示',
              message: '敬请期待！'
            }).then(() => {
              this.$router.push({path:'/'})
            })
          }
        })
      },
      showPlay:function(index,re){
        if( index == 1 ){
          this.show1 = re
        }else if( index == 2 ){
          this.getRole()
          this.show2 = re
        }else if( index == 3 ){
          this.show3 = re
        }else if( index == 4 ){
          this.show4 = re
        }
      },
      getRole:function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Winning/activity_config', {token:isUser}, res => {
         this.role=res.data.data
        })
      },
      getUserdatas: function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Winning/day_conut', {token:isUser}, res => {
          this.userdatas = res.data.data
        })
      },
      getDatas: function () {
        var isUser = localStorage.getItem("BLHuser")
        this.$api.post('WebApi/Member/Winning/index', {token:isUser}, res => {
          if( res.data.errCode == '0000' ){
            console.log(res.data.data)
//            this.getUserlist()
            this.datas = res.data.data
            this.$nextTick(() => {
              var _this = this
              this.turnplate.restaraunts = []
              $.each(res.data.data.activity_info,function(index,items){
                _this.turnplate.restaraunts.push(items.prize_name)
                 _this.turnplate.dengji.push(items.name)
                _this.turnplate.images.push(items.prize_img)
              })
              this.drawRouletteWheel()
              this.turnplate.bRotate = true
            })
          }else if(res.data.errCode == '5009'){
            this.$dialog.alert({
              title:'提示',
              message: '敬请期待！'
            }).then(() => {
//              this.$router.push({path:'/'})
            })
          }
//          else if(res.data.errCode == '5109'){
//            this.$dialog.alert({
//              title:'提示',
//              message: '敬请期待！'
//            }).then(() => {
//              this.$router.push({path:'/'})
//            })
//          }
        })
      },
      getUserlist:function () {
        this.$api.post('WebApi/Member/Winning/winning',null, res => {
          this.userlist = res.data.data
        })
      },
      rotateFn: function (item, txt,status_id) {
        var _this = this
        var angles = item * (360 / this.turnplate.restaraunts.length) - (360 / (this.turnplate.restaraunts.length * 2))
        if (angles < 270) {
          angles = 270 - angles
        } else {
          angles = 360 - angles + 270
        }
        var bRotateT = this.turnplate.bRotate
        this.$nextTick(() => {
          $('#wheelcanvas').stopRotate()
          $('#wheelcanvas').rotate({
            angle: 0,
            animateTo: angles + 1800,
            duration: 8000,
            callback: function () {
              if(status_id == null){
                _this.show3 = true
              }else{
                _this.show4 = true
                _this.truetext = txt
              }
              _this.turnplate.bRotate = true
            }
          })
        })
      },
      pointer () {
        if(this.turnplate.bRotate){
          this.turnplate.bRotate = false
          var isUser = localStorage.getItem("BLHuser")
          var _this = this
          this.$api.post('WebApi/Member/Winning/receivePrizes', {token:isUser,activity_id:this.datas.activity_info[0].activity_id}, res => {
            if (res.data.errCode == '0000') {
              this.userdatas.day_conut = this.userdatas.day_conut - 1
              var status_id = res.data.data.ok_status_id
              _this.pid=res.data.data.product_code;
              _this.goodid=res.data.data.ok_status_id;
              _this.goodtype=res.data.data.type;
              $.each(this.datas.activity_info,function(index,items){
                if( items.id == res.data.data.prize_id){
                  _this.rotateFn(index+1, _this.turnplate.restaraunts[index],status_id)
                }
              })
              /*if(status_id != null){
                this.$api.post('WebApi/Member/Winning/ok_status', {token:isUser,activity_winning_id:status_id}, res2 => {})
              }*/
            }else if(res.data.errCode == '1002'){
              this.$dialog.confirm({
                title: '提示',
                message: '您还未登录是否去登录？'
              }).then(() => {
                this.turnplate.bRotate = true
                  this.$router.push({path: '/login'})
              }).catch(() => {
                this.turnplate.bRotate = true
              });
            }else{
              this.turnplate.bRotate = true
              this.$toast(res.data.desc)
            }
          })
        }else{

        }
      },
      drawRouletteWheel () {
        var canvas = document.getElementById('wheelcanvas')
        if (canvas.getContext) {
          // 根据奖品个数计算圆周角度
          console.log(this.turnplate);
          var arc = Math.PI / (this.turnplate.restaraunts.length / 2)
          var ctx = canvas.getContext('2d')
          // 在给定矩形内清空一个矩形
          ctx.clearRect(0, 0, 422, 422)
          // strokeStyle 属性设置或返回用于笔触的颜色、渐变或模式
          ctx.strokeStyle = '#FFBE04'
          // font 属性设置或返回画布上文本内容的当前字体属性
          ctx.font = '18px Microsoft YaHei'
          for (var i = 0; i < this.turnplate.restaraunts.length; i++) {
            var angle = this.turnplate.startAngle + i * arc
            ctx.fillStyle = this.turnplate.colors[i]
            ctx.beginPath()
            //  arc(x,y,r,起始角,结束角,绘制方向) 方法创建弧/曲线（用于创建圆或部分圆）
            ctx.arc(211, 211, this.turnplate.outsideRadius, angle, angle + arc, false)
            ctx.arc(211, 211, this.turnplate.insideRadius, angle + arc, angle, true)
            ctx.stroke()
            ctx.fill()
            // 锁画布(为了保存之前的画布状态)
            ctx.save()

            // ----绘制奖品开始----
            ctx.fillStyle = '#2d0c02'
            var text = this.turnplate.restaraunts[i]
             if(text.length>12){
                text = text.slice(0,12)+'...'
              }
            var imgObj = new Image();
            imgObj.src = this.turnplate.images[i]
            var lineHeight = 25
            // translate方法重新映射画布上的 (0,0) 位置
            ctx.translate(211 + Math.cos(angle + arc / 2) * this.turnplate.textRadius, 211 + Math.sin(angle + arc / 2) * this.turnplate.textRadius)

            // rotate方法旋转当前的绘图
            ctx.rotate(angle + arc / 2 + Math.PI / 2)

            /** 下面代码根据奖品类型、奖品名称长度渲染不同效果，如字体、颜色、图片效果。(具体根据实际情况改变) **/
            if (text.indexOf('M') > 0) { // 流量包
              var texts = text.split('M')

              for (var j = 0; j < texts.length; j++) {
                ctx.font = j === 0 ? 'bold 20px Microsoft YaHei' : '16px Microsoft YaHei'
                if (j === 0) {
                  ctx.fillText(texts[j] + 'M', -ctx.measureText(texts[j] + 'M').width / 2, j * lineHeight)
                } else {
                  ctx.fillText(texts[j], -ctx.measureText(texts[j]).width / 2, j * lineHeight)
                }
              }
            } else if (text.indexOf('M') === -1 && text.length > 6) { // 奖品名称长度超过一定范围
              text = text.substring(0, 6) + '||' + text.substring(6)
              var textst = text.split('||')
              for (var ji = 0; ji < textst.length; ji++) {
                ctx.fillText(textst[ji], -ctx.measureText(textst[ji]).width / 2, ji * lineHeight)
              }
            } else {
              // 在画布上绘制填色的文本。文本的默认颜色是黑色
              // measureText()方法返回包含一个对象，该对象包含以像素计的指定字体宽度
              ctx.fillText(text, -ctx.measureText(text).width / 2, 0)
              // imgObj.onload = function(){ //onload必须使用
              //   ctx.drawImage(this,230,100,50,50)
              // }
            }
            // 添加对应图标
            /*if (text.indexOf('Q币') > 0) {
              var img = document.getElementById('shan-img')
              img.onload = function () {
                // ctx.drawImage(img, -15, 10) //本来第一次加载大转盘抽奖就会出现奖品图片，但是有点瑕疵没有解决所以注释了，现在第二次加载就会出现，
                //谁解决了来说下，帮助大家
              }
              ctx.drawImage(img, -15, 10)
            } else if (text.indexOf('谢谢参与') >= 0) {
              img = document.getElementById('sorry-img')
              img.onload = function () {
                // ctx.drawImage(img, -15, 10) //本来第一次加载大转盘抽奖就会出现奖品图片，但是有点瑕疵没有解决所以注释了，现在第二次加载就会出现，
                //谁解决了来说下，帮助大家
              }
              ctx.drawImage(img, -15, 10)
            }*/
            // 把当前画布返回（调整）到上一个save()状态之前
            ctx.restore()
            // 绘制奖品结束
          }
        }
      }
    },

  }
</script>

<style lang="less" scoped>
  .adventures{
    .adven-popup{
      background-color: inherit;
      width: 80%;
    }

    .hintbox{
      position: relative;
      .title-bg{
        line-height: 32px;
        width: 44%;
        height: 32px;
        position: absolute;
        left: 28%;
        top: -8px;
        background-image: url(/static/images/titlebg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        color: #fff;
        text-align: center;
        font-size: 16px;
        z-index: 40;
      }
      .overline{
        width: 90%;
        height: 25px;
        background: #fff;
        position: absolute;
        top: 0px;
        left: 5%;
        z-index: 30;
      }
      .hintclear{
        img{
          width: 20px;
          border-radius:50%;
        }
        position: absolute;
        left: 50%;
        margin-left: -10px;
        bottom: -40px;
      }
      .hinttit{
        font-size: 18px;
        text-align: center;
        padding: 15px 0;
      }
      .hintcent1{
        border-radius: 10px;
        padding: 30px;
        /*background-image: url("/static/images/adven-adven-popup-tit.png");*/
        /*background-size: 100% auto;*/
        /*background-repeat: no-repeat;*/
        height: 230px;
        overflow-y: scroll;
      }
      .hintcent{
        border-radius: 10px;
        padding: 30px;
        /*background-image: url("/static/images/adven-adven-popup-tit.png");*/
        /*background-size: 100% auto;*/
        /*background-repeat: no-repeat;*/
        height: 230px;
        overflow-y: scroll;
        .tit{
          font-size: 16px;
        }
        p{
          width:100%;
        }
        .van-button{
          height: 45px;
          padding: 0 70px;
          border-radius: 20px;
          margin-top:165px;
          font-size: 16px;
          background-size:80% 80%;
          border: none;
          color: #fff!important;
        }
      }
    }
    .userlist-popup{
      .title-bg{
        line-height: 32px;
        width: 44%;
        height: 32px;
        position: absolute;
        left: 28%;
        top: -8px;
        background-image: url(/static/images/titlebg.png);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        color: #fff;
        text-align: center;
        font-size: 16px;
        z-index: 40;
      }
      .overline{
        width: 90%;
        height: 25px;
        background: #fff;
        position: absolute;
        top: 0px;
        left: 5%;
        z-index: 30;
      }
      .hintcent{
        height: 320px;
        overflow-y: scroll;
        padding: 0;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        .hinttit{
          position: absolute;
          width: 100%;
          text-align: center;
          top: 0;
          padding-top: 30px;
          background-image: url(/static/images/adven-adven-popup-tit.jpg);
          background-size: 100%;
          border-radius: 15px;
        }
        .userlist{
          padding: 3.5px 30px;
          margin-top: 30px;
        }
      }
    }
    .truetext{
      position: absolute;
      text-align: center;
      color:#FA5A5A;
     top: 48%;
     left:50%;
     width:170px;
     margin-left:-85px;
      font-size: 13px;
    }
    .true-popup .hintcent{
      background-image: url("/static/images/adven-popup-truebg2.png");
      background-size: 100% 100%;
      text-align: center;
      img{
        width: 150px;
        height: 116px;
        margin-top: 80px;
      }
    }
    .false-popup .hintcent{
      background-image: url("/static/images/adven-popup-falsebg.png");
      background-size: 100% 100%;
      text-align: center;
      height: 220px;
      img{
        width: 50px;
        margin-top: 110px;
      }
    }
    .false-popup .hintcent1{
      background-image: url("/static/images/adven-popup-falsebg2.png");
      background-size: 100% 100%;
      text-align: center;
      height: 220px;
      img{
        width: 50px;
        margin-top: 110px;
      }
      .van-button{
          height: 45px;
          padding: 0 70px;
          border-radius: 20px;
          margin-top:165px;
          font-size: 16px;
          background-size:80% 80%;
          border: none;
          color: #fff!important;
        }
    }
    .van-content{
      padding-top:0;
      /*margin-top: 46px;*/
      min-height: 100vh;
      background-image: url("/static/images/adventures-bg.png");
      background-size: 100% 100%;
      padding-bottom: 0;
      
      .adventures-bot-btn{
        text-align: center;
        padding: 0 20px;
        .van-button{
          font-size: 16px;
          width: 90px;
          height: 32px;
          color: #fff;
          background: transparent;
          /*box-shadow: 0px 4px 12px #333;*/
          margin-top: 12%;
        }
      }
    }
    .awardRotate{
      .usertit{
        height: 30px;
        line-height: 30px;
        width: 226px;
        margin: 0 auto;
        margin-bottom: 10px;
        text-align: center;
        font-size: 14px;
        color: #fff;
        background-image: url("/static/images/getTimes.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
        .getTimes{
            span{
              margin: 0 5px;
              font-weight: bold;
              font-size: 16px;
            }
        }
      }
      padding-top: 44%;
    }
    .banner{display:block;width:95%;margin: 0 auto;margin-bottom: 20px;}
    .banner .turnplate{display:block;width:100%;position:relative;padding: 0 5%;box-sizing: border-box;z-index: 100}
    .banner .turnplate canvas.item{width:94%;background-image:url(/static/images/turnplate-bg.png);background-size:100%;margin-left: 3%}
    .banner .turnplate img.pointer{
      position: absolute;
      width: 36%;
      height: 42%;
      left: 32%;
      top: 27%;
    }
    .turnplate-bottom{
      position: relative;
      bottom: 40px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100;
      top: 0;
      margin-top: -7%;
      img{
        width: 72%;
        margin-left: 14%;
      }
    }
    .jianglist{
      height: 60px;
      background: url(/static/images/jiangbg.png) no-repeat center;background-size: 100% 100%;
      margin: 15px;
      padding: 5px 20px!important;
      .van-col{
        color: #fff;
      }
    }
    .prizeName{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
    }
    .getprize{
      height: 46px;
      line-height: 17px;
      background: #fff;
      margin-top: 7px;
      border-radius: 4px;
      padding: 6px 0 0 0px;
      color: #FA5A5A!important;
      i{
        line-height: 39px;
        margin-left: -2px;
        color: #FA5A5A!important;
      }
    }
    .hadget{
      height: 46px;
      line-height: 17px;
      background: #666;
      margin-top: 7px;
      border-radius: 4px;
      padding: 6px 0 0 0px;
      color: #333!important;
      i{
        line-height: 39px;
        margin-left: -2px;
        color: #333!important;
      }
    }
    .prizeTime{
      position: absolute;
      top: 37px;
      left: 20px;
      font-size: 12px;
      color: #fff;
      height: 16px;
      line-height: 16px;
    }
  }
  /* 大转盘样式 */
#jiangping-img{
  width:50px;
  height:50px;
  }
  .spone{
    display:block;
    width:20%;
    float:left;
    overflow:hidden;text-overflow:ellipsis;white-space:nowrap;
  }
  .sptow{
    display:block;
    width:70%;
    float:left;
    margin-left:10%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/activity/adventures.vue